import { getRandom12digitsAlphaNum } from './getRandom12digitsAlphaNum';

/** Shape: 1630000000000-1f8b2bcfff00 */
export const getBaseId = (): string =>
  `${new Date().getTime()}-${getRandom12digitsAlphaNum()}`;
